<template>
    <div class="ur-context-item">
        <slot/>
    </div>
</template>

<script>
    export default {
        name: 'ur-context-item',
    };
</script>

<style scoped lang="scss">
.ur-context-item{padding: 2px 4px;}
</style>
